var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "mt-3 mb-3" },
    _vm._l(_vm.availabilityPerSlot, function (day, dayIndex) {
      return _c(
        "div",
        {
          key: dayIndex,
          staticClass: "Availability-table-container is-flex mt-2",
        },
        [
          day.length
            ? _c(
                "div",
                [
                  _c(
                    "p",
                    {
                      staticClass: "hb-fonts-body-regular has-text-weight-bold",
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            dayIndex ? _vm.secondDayDate : _vm.firstDayDate
                          ) +
                          "\n      "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm._l(day, function (time, timeIndex) {
                    return _c(
                      "p",
                      {
                        key: timeIndex,
                        staticClass:
                          "hb-fonts-body-regular has-text-weight-light pl-4",
                      },
                      [
                        timeIndex < day.length - 1
                          ? _c("span", [
                              _vm._v(
                                "\n          " +
                                  _vm._s(time[0]) +
                                  ":00 - " +
                                  _vm._s(day[timeIndex + 1][0]) +
                                  ":00\n        "
                              ),
                            ])
                          : _vm._e(),
                      ]
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          day.length
            ? _c(
                "div",
                [
                  _c(
                    "p",
                    {
                      staticClass:
                        "hb-fonts-body-regular has-text-weight-bold has-text-centered",
                    },
                    [_vm._v("\n        Freie Termine\n      ")]
                  ),
                  _vm._v(" "),
                  _vm._l(day, function (time, timeIndex) {
                    return _c(
                      "p",
                      {
                        key: timeIndex,
                        staticClass:
                          "hb-fonts-body-regular has-text-weight-light has-text-centered",
                      },
                      [
                        timeIndex < day.length - 1
                          ? _c("span", [_vm._v(_vm._s(time[1]))])
                          : _vm._e(),
                      ]
                    )
                  }),
                ],
                2
              )
            : _vm._e(),
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }